import classNames from "classnames";
import { useEffect } from "react";
import { playSound, Sounds } from "../../models/Sounds";
import store from "../../store/store";
import Card from "../Card/Card";
import PlayerPicture from "../Players/PlayerPicture";
import RevealedCardData from "./RevealedCardData";
import "./Table.scss";

export default function TableResults() {
  const gameState = store.getState().game;
  const player = gameState.player;
  const players = gameState.players;
  const results = gameState.results;

  useEffect(() => {
    const playerResults = results.find(it => it.playerId === player?.data.playerId);

    if (playerResults && playerResults.score > 0) {
      playSound(Sounds.POSITIVE);
    }
    else {
      playSound(Sounds.NEGATIVE);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function getPlayer(playerId: string) {
    return gameState.players.find(it => it.playerId === playerId);
  }

  const gameTableClassNames = classNames({
    'game-table': true,
    'game-table_results': true,
    [`game-table-${players.length}`]: true
  });

  return (
    <>
      <div className={gameTableClassNames}>
        {results.length > 0 &&
          <div className="game-table_results_cards">
            {results.map((it, i) => {
              const player = getPlayer(it.playerId);

              return <div key={it.card.cardId} className="game-table_results_card">
                <Card
                  card={it.card}
                  cards={results.map(it => it.card)}
                  isSelected={it.isStoryteller}
                  isSelectable={true}
                />
                {player && (

                  <div className="game-table_results_card-owner">

                    <div  className="game-table_results_card-owner_player">
                      <PlayerPicture player={player} size={45} />
                      <div className="game-table_results_card-owner_score">+{it.score}</div>
                      <RevealedCardData ownerPlayerId={player.playerId} savedSentences={it.savedSentences} cardComments={it.cardComments} />
                    </div>

                    <div className="game-table_results_card-owner-info">
                        <div className="game-table_results_card-owner-info_score-details">
                          <span>G: +{it.guessScore}</span>
                          <span>M: +{it.matchCount}</span>
                          <span>S: +{it.storytellerScore + it.storytellerVoteCount + it.failedStorytellerScore}</span>
                        </div>
                    </div>
                  </div>
                )}

                <div className="game-table_results_voted">
                  {it.votedPlayerIds.map((votePlayerId) => {
                    const votedPlayer = getPlayer(votePlayerId);
                    const classes = classNames({
                      'storyteller': votedPlayer?.isStoryteller,
                      'wide': it.votedPlayerIds.length >= 1
                    });
                    return <PlayerPicture player={votedPlayer || null} size={45} key={votePlayerId} classes={classes} />
                  })}
                </div>
              </div>;
            }
            )}
          </div>
        }
      </div>
    </>

  )
}